import { SvgIcon } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';

export interface AppleIconProps {
  style?: CSSProperties;
}

export const AppleIcon = ({ style }: AppleIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{
        fontSize: '1em',
        color: '#000',
        ...style,
      }}
      width="25.21"
      height="30"
      viewBox="0 0 25.21 30"
    >
      <path
        d="M21.359,18.1a6.253,6.253,0,0,1,3.349-5.68,7.2,7.2,0,0,0-5.673-2.987c-2.378-.188-4.976,1.386-5.927,1.386C12.1,10.823,9.8,9.5,7.99,9.5c-3.737.06-7.709,2.98-7.709,8.921a16.693,16.693,0,0,0,.964,5.438c.857,2.458,3.952,8.486,7.18,8.385,1.688-.04,2.88-1.2,5.077-1.2,2.13,0,3.235,1.2,5.117,1.2,3.255-.047,6.055-5.526,6.872-7.99A6.639,6.639,0,0,1,21.359,18.1Zm-3.791-11A6.308,6.308,0,0,0,19.175,2.25a7.1,7.1,0,0,0-4.548,2.337A6.407,6.407,0,0,0,12.913,9.4,5.625,5.625,0,0,0,17.568,7.106Z"
        transform="translate(-0.281 -2.25)"
      />
    </SvgIcon>
  );
};
